import { string, object, number } from "yup";

const categoryValidationSchema = object().shape({
  name: string().required("REQUIRED"),
  position: string().required("REQUIRED"),
  rank: number().positive().min(0).required("REQUIRED"),
});

export default categoryValidationSchema;
